// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"ts-z","giftOrPromoSelector":"us-z","disabled":"vs-z","subTitle":"ws-z","selectShipAddressMessage":"xs-z","changePayment":"ys-z"};